import React from 'react'

export default React.createClass({
  render() {
    return (
      <div>
        <h1>Not Found</h1>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/app/components/NoMatch.js